import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import './Arrow.scss';

class Arrow extends React.Component {
	render() {
		return (
			<Common
				render={({ labels }) => {
					const { direction, classes, onClickEvent } = this.props;
					const type =
						direction === 'right'
							? labels.get('NEXT')
							: labels.get('PREVIOUS');
					const arrowKey =
						direction === 'right'
							? labels.get('RIGHT_ARROW')
							: labels.get('LEFT_ARROW');
					const marginClass = direction === 'right' ? 'mr-4' : 'ml-4';
					let buttonClasses = ['btn-carousel', 'p-0', marginClass];
					if (classes) {
						buttonClasses = [...buttonClasses, ...classes];
					}
					const iconClasses = [
						'ddc-icon',
						'ddc-icon-carousel-arrow',
						`ddc-icon-carousel-arrow-${direction}`,
						'd-block'
					];
					return (
						<Button
							className={buttonClasses.join(' ')}
							onClick={onClickEvent.bind(this)}
							bsStyle={null}
							title={`${type} (${arrowKey})`}
							aria-label={`${type} (${arrowKey})`}
							role="button"
						>
							<i className={iconClasses.join(' ')} />
						</Button>
					);
				}}
			/>
		);
	}
}
Arrow.defaultProps = {
	classes: []
};

Arrow.propTypes = {
	direction: PropTypes.string.isRequired,
	onClickEvent: PropTypes.func.isRequired,
	classes: PropTypes.arrayOf(PropTypes.string)
};

export default Arrow;
